<template>
  <Modal
    :id="'cmp-distribution-reports-shop_management_report_modal'"
    @cancelled="onCancel"
  >
    <template slot="header">{{ $t('shop_management') }}</template>
    <template slot="body">
      <NTable
        :id="'distribution-reports-shop_management_report_list'"
        :items="list"
        :config="tableConfig"
        :headers="headers"
        class="shop_management_report_list"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('external_table')">
              <span
                class="txtov"
                :title="
                  item['external_table'] == 'digital_shop'
                    ? 'Digital'
                    : 'Physical'
                "
              >
                {{
                  item["external_table"] == "digital_shop"
                    ? "Digital"
                    : "Physical"
                }}
              </span>
            </td>
            <td v-bind="tdcon('text01')">
              <span class="txtov" :title="item['text01']">
                {{ item["text01"] }}
              </span>
            </td>
            <td v-bind="tdcon('text02')">
              <span class="txtov" :title="item['text02']">
                {{ item["text02"] }}
              </span>
              <TextField2
                :id="'text02'"
                :showLabel="false"
                :value="item['text02']"
                @blur="(e) => onTextFieldValueChange(e, item)"
              />
            </td>
            <td v-bind="tdcon('external_id')">
              <Dropdown2
                :id="'external_id'"
                class="dbox1"
                :showLabel="false"
                :options="digital_accounts_TV"
                :selected="
                  digital_accounts_TV.find((e) => e.value == item.external_id)
                "
                :placeholder="$t('transfer to account')"
                v-on:selectedChange="
                  (e) => onDropdownChange('external_id', e, item)
                "
                :bb="'0px'"
              />
            </td>
            <td v-bind="tdcon('external_id2')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="`${item['external_id2']}`"
                    :id="`${item['external_id2']}`"
                    :checked="item['external_id2'] == '1'"
                    @click="(e) => onCheckboxChange(e, item)"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onSave"
      >
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { ReportService } from "../../services/reports.service";
import InputField from "../../../../plugins/text-field/input-field";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import TextInput from "../../../../plugins/text-field/text-input";
import { async } from "ramda-adjunct";
export default {
  components: {
    InputField,
    Modal,
  },
  props: ["filteredData"],
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      tableConfig: createNTableConfig({
        headerStyle: 4,
        rowHeight: 30,
        fullHeight: true,
        footer: false,
      }),
      validationResult: {},
      filterSelectionData: {
        group_by: null,
        chapter: null,
        top_ten: null,
      },

      shopManagementReportModel: { digital_accounts: [] },
    };
  },
  mounted: function () {
    this.getShopManagementReportModalData();
  },
  computed: {
    list: function () {
      return this.shopManagementReportModel.shops || [];
    },

    headers: function () {
      return [
        createTableHeader("external_table", { text: this.$t("channel") }),
        createTableHeader("text01", {
          text: this.$t("current_name"),
        }),
        createTableHeader("text02", {
          text: this.$t("new_name"),
        }),
        createTableHeader("external_id", {
          text: this.$t("transfer_to_account"),
        }),
        createTableHeader("external_id2", {
          text: this.$t("excl mechanicals"),
        }),
      ];
    },
    digital_accounts_TV: function () {
      return createTV(
        this.shopManagementReportModel.digital_accounts || [],
        "account_name",
        "account_id"
      );
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
  },

  methods: {
    onCheckboxChange: async function (e, item) {
      const value = e.target.checked ? "1" : "0";
      const result = await ReportService.modify({
        name: "external_id2",
        value: value,
        kVal: item.relation_id,
      });
    },
    getShopManagementReportModalData: async function () {
      const result = await ReportService.getShopManagementReportModalData();
      this.shopManagementReportModel = {
        ...this.shopManagementReportModel,
        ...result.data,
      };
    },

    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },

    onSave: async function () {
      const res = await ReportService.updateShopNames();

      this.onCancel();
    },
    onDropdownChange: async function (name, value, item) {
      console.log("value", { name, value });
      item.external_id = value.value;
      const result = await ReportService.modify({
        name,
        value: value.value,
        kVal: item.relation_id,
      });
    },

    onTextFieldValueChange: async function ({ name, value }, item) {
      const result = await ReportService.modify({
        name,
        value,
        kVal: item.relation_id,
      });
      ReportService.checkShopNames({
        shop: value,
        relation_id: item.relation_id,
      }).then((res) => {});
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-reports-shop_management_report_modal {
  .shop_management_report_list {
    --ntable-height: 400px !important;
    --tb-layout: fixed;
    tr {
      padding-left: 5px;
    }
  }
  .dt-modal--body {
    tbody {
      margin-left: 0px;
      background: #f8f8f8;
      display: flex;
      flex-direction: column;
      border: 1px solid var(--sprt-5);
      border-radius: 3px;
      padding-bottom: 10px;
      max-height: var(--body-height);
      min-height: var(--body-height);
    }
  }
  .dt-modal--options {
    button {
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 0px 10px;
      }
    }
  }
  .checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .select-checkbox {
      padding-right: 5px;
    }
  }
}
</style>
